const MAPBOX_CSS_URL = 'https://api.mapbox.com/mapbox-gl-js/v3.6.0/mapbox-gl.css';
const MAPBOX_JS_URL = 'https://api.mapbox.com/mapbox-gl-js/v3.6.0/mapbox-gl.js';
const MAP_FONT_URL = 'https://fonts.googleapis.com/css2?family=Sofia+Sans+Condensed:wght@500;600;700&display=swap';

let mapboxPromise = null;

function loadMapFont() {
    if (document.querySelector(`link[href="${MAP_FONT_URL}"]`)) return;

    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = MAP_FONT_URL;
    document.head.appendChild(fontLink);
}

function loadMapbox() {
    loadMapFont();

    if (window.mapboxgl) return Promise.resolve(window.mapboxgl);
    if (mapboxPromise) return mapboxPromise;

    mapboxPromise = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[href="${MAPBOX_CSS_URL}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = MAPBOX_CSS_URL;
            document.head.appendChild(link);
        }

        const existingScript = document.querySelector(`script[src="${MAPBOX_JS_URL}"]`);
        if (existingScript) {
            existingScript.addEventListener('load', () => resolve(window.mapboxgl), { once: true });
            existingScript.addEventListener('error', reject, { once: true });
            return;
        }

        const script = document.createElement('script');
        script.src = MAPBOX_JS_URL;
        script.async = true;
        script.onload = () => {
            if (window.mapboxgl) resolve(window.mapboxgl);
            else reject(new Error('Mapbox GL loaded without exposing window.mapboxgl.'));
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });

    return mapboxPromise;
}

function escapeHtml(value) {
    return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function iconBag() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
}

function iconFork() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>';
}

function iconTicket() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9a3 3 0 0 0 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 0 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>';
}

function iconStore() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7 4 3h16l2 4"/><path d="M2 7h20v2a4 4 0 0 1-8 0 4 4 0 0 1-8 0 4 4 0 0 1-4 0"/><path d="M4 11v9a1 1 0 0 0 1 1h6v-6h2v6h6a1 1 0 0 0 1-1v-9"/></svg>';
}

function iconHeart() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z"/><path d="M3.22 8.5h2.61l1.34-1.5 1.42 3 1.44-2.5h1.4"/></svg>';
}

function iconTrain() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="3" width="16" height="15" rx="3"/><path d="M4 11h16"/><path d="M12 3v8"/><path d="M8 19l-2 3"/><path d="M18 22l-2-3"/></svg>';
}

function iconMapPin() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg>';
}

const categoryDefaults = [
    { name: 'Shopping', label: 'Retail', color: 'var(--cat-shopping)', icon: iconBag() },
    { name: 'Food & Beverage', color: 'var(--cat-food)', icon: iconFork() },
    { name: 'Entertainment', color: 'var(--cat-entertainment)', icon: iconTicket() },
    { name: 'Convenience', color: 'var(--cat-convenience)', icon: iconStore() },
    { name: 'Health & Wellness', color: 'var(--cat-wellness)', icon: iconHeart() },
    { name: 'Transit', color: 'var(--cat-transit)', icon: iconTrain() },
];

const fallbackCategoryColors = ['#876f9f', '#964e38', '#58716d', '#a16a5a', '#6f755d'];

export default function poiMap(config = {}) {
    return {
        mapId: config.mapId,
        pois: config.pois || [],
        configuredCategories: config.categories || [],
        mapboxToken: config.mapbox?.accessToken,
        mapboxStyle: config.mapbox?.styleUrl,
        focalPoint: { lng: -87.663065, lat: 41.917073 },
        desktopStartingZoom: 14.75,
        mobileStartingZoom: 14.2,
        minZoom: 12.25,
        maxZoom: 16,
        shuttleUrl: config.shuttleUrl || '/assets/map/shuttle.geojson',
        stopsUrl: config.stopsUrl || '/assets/map/stops.geojson',
        map: null,
        resizeObserver: null,
        loading: true,
        error: false,
        loadingMessage: 'Loading POIs...',
        markers: [],
        activeCategories: [],
        shuttleVisible: false,

        get categories() {
            const defaultByName = new Map(categoryDefaults.map((category) => [category.name, category]));
            const poiCategoryNames = [...new Set(this.pois.map((poi) => poi.category).filter(Boolean))];
            const categoryNames = this.configuredCategories.length
                ? this.configuredCategories
                : poiCategoryNames;

            const names = categoryNames.length ? categoryNames : categoryDefaults.map((category) => category.name);

            return names.map((name, index) => (
                defaultByName.get(name) || {
                    name,
                    color: fallbackCategoryColors[index % fallbackCategoryColors.length],
                    icon: iconMapPin(),
                }
            ));
        },

        get allCategoriesActive() {
            return this.activeCategories.length === this.categories.length;
        },

        async init() {
            try {
                if (!this.mapboxToken || !this.mapboxStyle) {
                    throw new Error('Mapbox environment values are not configured.');
                }

                const mapboxgl = await loadMapbox();
                this.activeCategories = this.categories.map((category) => category.name);
                mapboxgl.accessToken = this.mapboxToken;

                await this.waitForContainer();

                this.map = new mapboxgl.Map({
                    container: this.mapId,
                    style: this.mapboxStyle,
                    center: [this.focalPoint.lng, this.focalPoint.lat],
                    zoom: window.matchMedia('(min-width: 48rem)').matches
                        ? this.desktopStartingZoom
                        : this.mobileStartingZoom,
                    minZoom: this.minZoom,
                    maxZoom: this.maxZoom,
                    cooperativeGestures: true,
                    scrollZoom: false,
                    touchZoomRotate: false,
                    doubleClickZoom: false,
                    boxZoom: false,
                    keyboard: false,
                    attributionControl: false,
                });
                this.setupResizeHandling();

                this.loadingMessage = 'Loading map...';
                await this.waitForStyleReady();
                this.map.resize();
                this.keepDefaultBuildingsVisible();

                this.renderMarkers(mapboxgl);
                this.map.on('moveend', () => this.updateLabelPlacement());
                this.map.on('zoomend', () => this.updateLabelPlacement());
                requestAnimationFrame(() => {
                    this.map.resize();
                    this.updateLabelPlacement();
                });

                this.loading = false;
                this.loadTransitShuttle();
            } catch (error) {
                console.error('Failed to initialize map', error);
                this.error = true;
                this.loadingMessage = 'The map could not load. Check the Mapbox token, POI data, and GeoJSON assets.';
            }
        },

        waitForStyleReady() {
            if (this.map?.isStyleLoaded()) return Promise.resolve();

            return new Promise((resolve) => {
                let resolved = false;
                const done = () => {
                    if (resolved) return;
                    resolved = true;
                    clearTimeout(timeout);
                    resolve();
                };
                const timeout = setTimeout(done, 4000);

                this.map.once('style.load', done);
                this.map.once('load', done);
            });
        },

        waitForContainer() {
            const container = document.getElementById(this.mapId);
            let attempts = 0;

            return new Promise((resolve, reject) => {
                const check = () => {
                    const rect = container?.getBoundingClientRect();

                    if (rect?.width && rect?.height) {
                        resolve();
                        return;
                    }

                    attempts += 1;
                    if (attempts > 120) {
                        reject(new Error('Map container has no rendered dimensions.'));
                        return;
                    }

                    requestAnimationFrame(check);
                };

                check();
            });
        },

        setupResizeHandling() {
            const container = this.map?.getContainer();
            if (!container) return;

            this.resizeObserver = new ResizeObserver(() => {
                if (!this.map) return;
                this.map.resize();
                this.updateLabelPlacement();
            });
            this.resizeObserver.observe(container);
            window.addEventListener('resize', () => {
                if (!this.map) return;
                this.map.resize();
                this.updateLabelPlacement();
            });
        },

        renderMarkers(mapboxgl) {
            this.pois.forEach((poi) => {
                if (!Number.isFinite(poi.lat) || !Number.isFinite(poi.lng)) return;

                const category = this.categories.find((item) => item.name === poi.category);
                if (!category) return;

                const el = document.createElement('div');
                el.className = 'poi-map-marker';
                el.dataset.category = poi.category;
                el.innerHTML = `
                    <div class="poi-map-marker-label">${escapeHtml(poi.name)}</div>
                    <div class="poi-map-marker-pin-wrap">
                        <div class="poi-map-marker-circle" style="background:${category.color}">${category.icon}</div>
                    </div>
                `;

                const popup = new mapboxgl.Popup({ offset: 12, closeButton: false }).setHTML(`
                    <div class="poi-map-popup-title">${escapeHtml(poi.name)}</div>
                    <div class="poi-map-popup-sub">${escapeHtml(poi.subcategory || poi.category)}</div>
                    <div class="poi-map-popup-desc">${escapeHtml(poi.description || '')}</div>
                `);

                const marker = new mapboxgl.Marker({ element: el, anchor: 'center' })
                    .setLngLat([poi.lng, poi.lat])
                    .setPopup(popup)
                    .addTo(this.map);

                if (poi.category === 'Transit') marker.getElement().style.zIndex = 20;

                this.markers.push({ marker, el, category: poi.category });
            });
        },

        zoomIn() {
            if (this.map) this.map.zoomIn();
        },

        zoomOut() {
            if (!this.map) return;
            this.map.zoomTo(Math.max(this.minZoom, this.map.getZoom() - 1));
        },

        keepDefaultBuildingsVisible() {
            ['building', 'building-outline'].forEach((layerId) => {
                if (this.map.getLayer(layerId)) {
                    this.map.setLayerZoomRange(layerId, 10, 24);
                }
            });
        },

        async loadTransitShuttle() {
            if (!this.map) return;
            if (this.map.getLayer('transit-shuttle-line') && this.map.getLayer('transit-shuttle-stops')) {
                this.setShuttleVisibility(this.shuttleVisible);
                return;
            }

            let shuttleData;
            let stopsData;

            try {
                [shuttleData, stopsData] = await Promise.all([
                    fetch(this.shuttleUrl).then((response) => response.json()),
                    fetch(this.stopsUrl).then((response) => response.json()),
                ]);
            } catch (error) {
                console.warn('Transit shuttle data could not be loaded.', error);
                return;
            }

            if (!this.map.getSource('transit-shuttle-line')) {
                this.map.addSource('transit-shuttle-line', { type: 'geojson', data: shuttleData });
            }
            if (!this.map.getLayer('transit-shuttle-line')) {
                this.map.addLayer({
                    id: 'transit-shuttle-line',
                    type: 'line',
                    source: 'transit-shuttle-line',
                    layout: {
                        'line-cap': 'round',
                        'line-join': 'round',
                    },
                    paint: {
                        'line-color': '#876f9f',
                        'line-width': 3,
                        'line-opacity': 0.95,
                    },
                });
            }

            if (!this.map.getSource('transit-shuttle-stops')) {
                this.map.addSource('transit-shuttle-stops', { type: 'geojson', data: stopsData });
            }
            if (!this.map.getLayer('transit-shuttle-stops')) {
                this.map.addLayer({
                    id: 'transit-shuttle-stops',
                    type: 'circle',
                    source: 'transit-shuttle-stops',
                    paint: {
                        'circle-color': '#876f9f',
                        'circle-radius': 3,
                        'circle-stroke-color': '#ffffff',
                        'circle-stroke-width': 1,
                    },
                });
            }

            this.setShuttleVisibility(this.shuttleVisible);
        },

        setShuttleVisibility(visible) {
            const visibility = visible ? 'visible' : 'none';
            ['transit-shuttle-line', 'transit-shuttle-stops'].forEach((id) => {
                if (this.map.getLayer(id)) this.map.setLayoutProperty(id, 'visibility', visibility);
            });
        },

        toggleShuttle() {
            this.shuttleVisible = !this.shuttleVisible;
            this.loadTransitShuttle();
            this.setShuttleVisibility(this.shuttleVisible);
        },

        toggleAllCategories() {
            this.activeCategories = this.allCategoriesActive
                ? []
                : this.categories.map((category) => category.name);
            this.updateMarkerVisibility();
        },

        showOnlyCategory(name) {
            this.activeCategories = [name];
            this.updateMarkerVisibility();
        },

        updateMarkerVisibility() {
            this.markers.forEach((item) => {
                item.el.classList.toggle('is-hidden', !this.activeCategories.includes(item.category));
            });
            this.updateLabelPlacement();
        },

        updateLabelPlacement() {
            if (!this.map) return;

            const containerRect = this.map.getContainer().getBoundingClientRect();
            const threshold = containerRect.top + 60;

            this.markers.forEach((item) => {
                const rect = item.el.getBoundingClientRect();
                item.el.classList.toggle('label-below', rect.top < threshold);
            });

            this.resolveLabelCollisions();
        },

        resolveLabelCollisions() {
            const gap = 2;
            const visible = this.markers.filter((item) => !item.el.classList.contains('is-hidden'));
            const labels = visible.map((item) => {
                const label = item.el.querySelector('.poi-map-marker-label');
                label.classList.remove('label-suppressed');
                return label;
            });

            const placed = [];
            labels.forEach((label) => {
                const rect = label.getBoundingClientRect();
                const box = {
                    left: rect.left - gap,
                    right: rect.right + gap,
                    top: rect.top - gap,
                    bottom: rect.bottom + gap,
                };
                const overlapsPlaced = placed.some((placedBox) => (
                    box.left < placedBox.right
                    && box.right > placedBox.left
                    && box.top < placedBox.bottom
                    && box.bottom > placedBox.top
                ));

                if (overlapsPlaced) label.classList.add('label-suppressed');
                else placed.push(box);
            });
        },

        zoomPlusIcon() {
            return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
        },

        zoomMinusIcon() {
            return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
        },
    };
}
